import { Fragment, PureComponent } from 'react';
import classNames from 'classnames';
import { getCurrentParams } from '@hc/redux-saga-router-plus/hclib/selectors';
import { MarkerPopup as MarkerPopupLeaflet } from 'hcmaps-leaflet';
import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  COMP_TYPE_DEFAULT,
  MAP_CONTROL_TYPE_HEATMAP,
  MAP_ID_REPORT
} from 'legacy/appstore/constants';
import { VIEWS } from 'legacy/routes/constants';

import { buildMarker } from 'legacy/utils/maps';
import { propertyTypeToAbbr } from 'legacy/utils/property-types';

import { toastShow } from 'actions/toast';
import { vrRouteChange } from 'actions/navigation';
import {
  reportToggleHeaderMapControls,
  reportActiveMapLayersChanged
} from 'actions/property-explorer';
import { saveReport } from 'actions/edit-report';

import {
  getSubjectAdjusted,
  getSubjectLocationUnknown,
  getSubjectMarkerClassNames,
  getSubjectLocationUserDefined
} from 'selectors/subject';
import { getToken } from 'selectors/account-details';
import {
  getReportIsShowingHeaderMapControls,
  getReportActiveMapLayerIds
} from 'selectors/property-explorer';
import { getMqSmallMediumAndUp, getScreenSize } from 'selectors/match-media';
import { getIsAttemptingLoadFullReport } from 'selectors/property-search';

import LocationUnknownWarningContainer from 'legacy/containers/location-unknown-warning';
import UserDefinedLocationMarkerPopupContainer from 'legacy/containers/user-defined-location-marker-popup';

import Maps from 'legacy/containers/maps';

import homeIcon from 'legacy/assets/svg-inline/home.svg';

const mapStateToProps = (state, ownProps) => {
  const isMobile = !getMqSmallMediumAndUp(state);
  const isShowingControls = getReportIsShowingHeaderMapControls(state);
  const disableLayerControls = getIsAttemptingLoadFullReport(state);
  const MapControlsSidePanel = ({ LayerControlsComponent }) => (
    <div
      className={classNames('map-controls-sidepanel', {
        'layer-controls-disabled': disableLayerControls
      })}
      data-hc-name={
        isShowingControls
          ? 'map-layer-controls-section-shown'
          : 'map-layer-controls-section'
      }
    >
      <h2
        className="map-controls-sidepanel--header"
        data-hc-name="map-layer-controls-header-text"
      >
        Explore Neighborhood Trends
      </h2>
      {LayerControlsComponent}
    </div>
  );
  const subject = getSubjectAdjusted(state);
  const locationUnknown = getSubjectLocationUnknown(state);
  const locationUserDefined = getSubjectLocationUserDefined(state);
  const subjectMarker = buildMarker({
    className: getSubjectMarkerClassNames(state),
    property: subject,
    label: homeIcon,
    isHomeStyle: true,
    iconSize: 'small',
    isSubject: true
  });
  const { latitude, longitude } = get(subject, ['geoLocation'], {});
  const shouldMapRender = !(
    latitude === undefined ||
    latitude === null ||
    longitude === undefined ||
    longitude === null
  );
  const areControlsToggled =
    !isMobile && getReportIsShowingHeaderMapControls(state);
  const MarkerPopup = locationUserDefined
    ? (marker) => {
        return (
          <MarkerPopupLeaflet>
            <UserDefinedLocationMarkerPopupContainer />
          </MarkerPopupLeaflet>
        );
      }
    : undefined;
  return {
    token: getToken(state),
    markers: subjectMarker ? [subjectMarker] : undefined,
    activeLayerIds: getReportActiveMapLayerIds(state) || [],
    disableScrollZoom: true,
    disableDragging: !ownProps.isFullMap && isMobile,
    // Re-init map viewport whenever a screen breakpoint is passed (i.e. small -> medium)
    fitMapTrigger: getScreenSize(state),
    fitMapPadding: {
      topLeft: [50, 75],
      bottomRight: [50, 50]
    },
    // Far enough out to provide some context, since we're only showing a single pin
    initialZoom: locationUnknown ? 12 : 15,
    referenceProperty: {
      type: propertyTypeToAbbr(subject.propertyType)
    },
    isHidingBaselayerControl: true,
    areControlsToggleable: !ownProps.isFullMap,
    isHidingControls: isMobile && !ownProps.isFullMap,
    areControlsToggled: areControlsToggled,
    visibleControlsType: MAP_CONTROL_TYPE_HEATMAP,
    showControlsClickActionLayers: isMobile
      ? () =>
          vrRouteChange({
            view: VIEWS.FULL_MAP_VALUE_REPORT,
            params: { maptype: 'subject' }
          })
      : reportToggleHeaderMapControls,
    fullWidthLegend: isMobile,
    LayersControlWrapper: !isMobile ? MapControlsSidePanel : undefined,
    // Used to reset map layers on change between reports
    currentAddress: getCurrentParams(state).steetAddress,
    // Don't render the map unless the subject has loaded.  Prevents location-based
    // map from rendering momentarily before the subject map renders.
    locationUnknown: getSubjectLocationUnknown(state),
    getMarkerPopup: MarkerPopup,
    shouldMapRender
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  toastShow: (message) => {
    dispatch(toastShow(message));
  },
  onShowMapControlsClick: (action) => {
    dispatch(action());
  },
  handleMapLayersChange: (activeLayerIds) => {
    dispatch(reportActiveMapLayersChanged(activeLayerIds));
    // Don't save report if the user viewing doesn't own it (aka shared report)
    dispatch(saveReport());
  }
});

/* Used to reset maps layers when switching between reports
 * and delay rendering the map until we have the subject property's location
 */
class MapsWrapper extends PureComponent {
  state = {};
  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentAddress !== prevProps.currentAddress) {
      this.setState({ shouldResetMapLayers: true });
    }
    if (this.state.shouldResetMapLayers) {
      this.setState({ shouldResetMapLayers: false });
    }
  }
  render() {
    return (
      this.props.shouldMapRender && (
        <Fragment>
          <Maps
            {...this.props}
            resetMapLayers={this.state.shouldResetMapLayers}
          />
          <LocationUnknownWarningContainer
            mapId={MAP_ID_REPORT}
            compType={COMP_TYPE_DEFAULT}
          />
        </Fragment>
      )
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapsWrapper);
